<script setup lang="ts">
import { onBeforeUnmount, onMounted, type PropType } from 'vue'
import { VIcons } from '@/shared/ui'

defineProps({
  items: {
    type: Array as PropType<number[]>,
    default: () => [],
  },
})

const emits = defineEmits(['clear'])

/**
 * Функция очистки списка выделенных объектов
 * @param event
 */
const clearList = (event: KeyboardEvent) => {
  if (event.key === 'Escape') emits('clear')
}

/* Назначаем прослушивателя событий */
onMounted(() => {
  document.addEventListener('keyup', clearList)
})

/* Удаляем прослушивателя событий */
onBeforeUnmount(() => {
  document.removeEventListener('keyup', clearList)
})
</script>

<template>
  <VSheet v-if="items.length" class="w-invent-map-info-item__header pa-4 mb-2" rounded>
    <div class="w-invent-map-info-item__title">
      <VIcons type="stack" class="w-invent-map-info-item__icon_default" />

      {{ $t('itf.selected_objects_count', { count: items.length }) }}
    </div>

    <VTooltip location="top" :open-delay="1000" :text="$t('itf.clear_selected')">
      <template #activator="{ props }">
        <VBtn
          icon
          density="compact"
          color="error"
          variant="plain"
          v-bind="props"
          @click.stop="emits('clear')"
        >
          <VIcons type="mop" />
        </VBtn>
      </template>
    </VTooltip>
  </VSheet>
</template>
